mutation UpdateZeroHarmReview($input: UpdateZeroHarmReviewInput!) {
  updateZeroHarmReview(input: $input) {
    zeroHarmReview {
      id
    }
  }
}
